import { FormControl, FormGroup } from '@angular/forms';
import { DeviceBase } from './device-base';
import { PropertyMetadata } from '../../properties/property-types';

export abstract class NetworkDeviceBase extends DeviceBase {
    constructor(formGroup: FormGroup, svgPath: string) {
        super(formGroup, svgPath);
        
        if (!formGroup.contains('LocalAddress')) {
            formGroup.addControl('LocalAddress', new FormControl(''));
        }
        if (!formGroup.contains('LocalPort')) {
            formGroup.addControl('LocalPort', new FormControl(1));
        }


        if (!formGroup.contains('ActiveDirection')) {
            formGroup.addControl('ActiveDirection', new FormControl('Both'));
        }
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            ...super.getPropertyMetadata(),
            {
                formControlName: 'LocalAddress',
                displayName: 'IP Address',
                inputType: { type: 'text' },
                order: 5,
                category: 'Network',
                hideOnMultipleSelection: true,
            },
            {
                formControlName: 'LocalPort',
                displayName: 'Port',
                inputType: { 
                    type: 'number',
                    min: 1,
                    max: 65535
                },
                order: 6,
                category: 'Network'
            },
            {
                formControlName: 'ActiveDirection',
                displayName: 'Enabled For',
                inputType: { 
                    type: 'select',
                    options: [
                        { value: 'Entry', label: 'Entry' },
                        { value: 'Exit', label: 'Exit' },
                        { value: 'Both', label: 'Both' }
                    ]
                },
                order: 6,
                category: 'Properties'
            }
        ];
    }
}
